import { render, staticRenderFns } from "./ClubController.vue?vue&type=template&id=6af5abb0&scoped=true"
import script from "./ClubController.vue?vue&type=script&lang=js"
export * from "./ClubController.vue?vue&type=script&lang=js"
import style0 from "./ClubController.vue?vue&type=style&index=0&id=6af5abb0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6af5abb0",
  null
  
)

export default component.exports